module.exports = __webpack_public_path__ + "static/fonts/akrobat-bold.9a0fb585.ttf";